function initializeVideoEvents() {
  $('.player-video').each(function () {
    const video = this;
    console.log(video);
    if (!$(video).data('timeupdate-initialized')) {
      
      // Function to set total time
      function setTotalTime() {
        const duration = video.duration;
        if (duration && !isNaN(duration)) {
          const container = $(video).closest('.player-container');
          const totalTimeDiv = container.find('.total-time');

          const totalMinutes = Math.floor(duration / 60);
          const totalSeconds = Math.floor(duration % 60);
          const formattedTotalTime = `${totalMinutes.toString().padStart(2, '0')}:${totalSeconds.toString().padStart(2, '0')}`;

          totalTimeDiv.text(formattedTotalTime);
        }
      }
      
      // Set total time when metadata is loaded
      $(video).on('loadedmetadata', setTotalTime);
      $(video).on('loadeddata', setTotalTime);
      $(video).on('canplay', setTotalTime);
      
      // Try to load metadata immediately if video is ready
      if (video.readyState >= 1) {
        setTotalTime();
      }
      
      $(video).on('timeupdate', function () {
        const currentTime = video.currentTime;
        const duration = video.duration;

        const container = $(video).closest('.player-container');
        const currentTimeDiv = container.find('.player-time');
        const progressBar = container.find('.player-progress-bar');
        const progress = container.find('.player-progress-line');

        const percentage = (currentTime / duration) * 100;
        const minutes = Math.floor(currentTime / 60);
        const seconds = Math.floor(currentTime % 60);
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        progress.css('width', percentage + '%');
        currentTimeDiv.text(formattedTime);
      });

      $(video).data('timeupdate-initialized', true);
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeVideoEvents);

// PLAY
$(document).off('click', '.player-video').on('click', '.player-video', function () {
  const el = $(this);
  const container = el.closest('.player-container');
  const video = container.find('.player-video').get(0);
  if (video.paused) {
    video.play();
    container.addClass('played');
    container.addClass('playing');
  } else {
    video.pause();
    container.removeClass('playing');
  }
});  

// PROGRESS
$(document).off('click', '.player-progress-bar').on('click', '.player-progress-bar', function (e) {
  const el = $(this);
  const container = el.closest('.player-container');
  const video = container.find('.player-video').get(0);
  const offset = el.offset();
  const width = el.width();
  const clickX = e.pageX - offset.left;
  const percentage = clickX / width;
  video.currentTime = video.duration * percentage;
});
